import { getAccessTokenFromCookie, getIdTokenFromCookie, logout } from "../util/authentication";
import {
  USER_ACCESS_API_GET_LATEST_USER_ACCESS_OVERRIDE_EVENT_BY_EMPLOYEE,
  USER_ACCESS_API_GET_SUPERUSER_ACCESS_BY_EMPLOYEE,
  USER_ACCESS_API_GET_USER_ACCESS_OVERRIDE_EVENTS_BY_STATION,
  USER_ACCESS_API_ADD_USER_ACCESS_OVERRIDE_EVENT,
  USER_ACCESS_API_GET_ACCESS_BASED_ON_TOKEN,
  USER_ACCESS_API_IS_USER_AUTHORIZED,
  USER_ACCESS_API_GET_FEATURE_ACCESS,
  TECH_USER_API_GET_PROXY_USER_SESSION,
} from "../util/constants";

export const fetchLatestUserAccessOverrideEvent = async (eid, station) => {
  const apiEndpoint =
    process.env.REACT_APP_USER_ACCESS_API +
    USER_ACCESS_API_GET_LATEST_USER_ACCESS_OVERRIDE_EVENT_BY_EMPLOYEE +
    "/" +
    eid +
    "/" +
    station;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestUserAccessOverrideEventsByStation = async (station, eid) => {
  const apiEndpoint =
    process.env.REACT_APP_USER_ACCESS_API +
    USER_ACCESS_API_GET_USER_ACCESS_OVERRIDE_EVENTS_BY_STATION +
    "/" +
    station +
    "/" +
    eid;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchSuperuserAccessByEmployee = async (eid) => {
  const apiEndpoint =
    process.env.REACT_APP_USER_ACCESS_API + USER_ACCESS_API_GET_SUPERUSER_ACCESS_BY_EMPLOYEE + "/" + eid;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const addUserAccessOverrideEvent = async (userAccessOverrideEventPayload) => {
  const apiEndpoint = process.env.REACT_APP_USER_ACCESS_API + USER_ACCESS_API_ADD_USER_ACCESS_OVERRIDE_EVENT;
  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(userAccessOverrideEventPayload),
  });
  return response;
};

export const fetchAccessBasedOnToken = async () => {
  const apiEndpoint = process.env.REACT_APP_USER_ACCESS_API + USER_ACCESS_API_GET_ACCESS_BASED_ON_TOKEN;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
      id_token: getIdTokenFromCookie(),
    },
  });
  return response;
};

export const isUserAuthorizedByServer = async (userSession) => {
  try {
    const apiEndpoint = process.env.REACT_APP_USER_ACCESS_API + USER_ACCESS_API_IS_USER_AUTHORIZED;
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
        "id-token": getIdTokenFromCookie(),
      },
      body: JSON.stringify(userSession),
    });
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

export const getFeatureAccess = async (featureAccessType) => {
  const apiEndpoint = process.env.REACT_APP_USER_ACCESS_API + USER_ACCESS_API_GET_FEATURE_ACCESS + '/' + featureAccessType;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
      "id-token": getIdTokenFromCookie(),
    },
  });
  if (response.status === 200){
    return response;
  }
  await logout();
};

export const getProxyUserSession = async (proxyEid) => {
  const apiEndpoint = process.env.REACT_APP_USER_ACCESS_API + TECH_USER_API_GET_PROXY_USER_SESSION;
  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
      "id-token": getIdTokenFromCookie(),
    },
    body: JSON.stringify({ proxyEid: proxyEid }),
  });

  if (response.status === 200) {
    return response;
  };
  await logout();
};
